<template>
	<div>
		<div role="main">
			<slot />
		</div>
		<FooterSection :links="footer" />
	</div>
</template>

<script setup lang="ts">
import { footer } from '~/assets/config/navigation.json'
</script>

<style lang="css" scoped>
div
{
	position: relative;
	z-index: 3;
}

div :deep(section)
{
	position: relative;
	width: 100%;
	background-color: rgb(var(--white));
	color: rgb(var(--black));
}

div :deep(section:first-child::before)
{
	content: '';
	position: absolute;
	top: -40px;
	left: 0;
	width: 100%;
	height: 41px;
	overflow: hidden;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M1200 120L0 16.48 0 0 1200 0 1200 120z' fill='%23faf9f6'%3E%3C/path%3E%3C/svg%3E");
	background-size: contain;
	background-position: bottom left;
	transform: rotate(180deg);
}

div :deep(section:last-child::after)
{
	content: '';
	position: absolute;
	bottom: -40px;
	left: 0;
	width: 100%;
	height: 41px;
	overflow: hidden;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M1200 120L0 16.48 0 0 1200 0 1200 120z' fill='%23faf9f6'%3E%3C/path%3E%3C/svg%3E");
	background-size: contain;
	background-position: bottom left;
}

div :deep(section h3)
{
	font-family: "brother-1816", sans-serif;
	font-size: 2.5rem;
	font-weight: 300;
	color: rgb(var(--blue));
	margin: 0 0 3rem;
	box-sizing: border-box;
}

div :deep(section p)
{
	line-height: 1.7;
	font-size: 1.25rem;
	text-align: justify;
}

@media screen and (max-width: 1030px)
{
	div :deep(section p)
	{
		font-size: 1.1rem;
	}
}

@media screen and (max-width: 700px)
{
	div :deep(section p)
	{
		font-size: 1rem;
		line-height: 1.4;
	}
}
</style>